import { render, staticRenderFns } from "./politica-privacidad.vue?vue&type=template&id=006e08e8&"
import script from "./politica-privacidad.vue?vue&type=script&lang=js&"
export * from "./politica-privacidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports